//import components
import Categories from "../components/dynamic/home/Categories";
import News from '../components/dynamic/home/News';
import Subscribe from "../components/dynamic/home/Subscribe";

//import locales
import { useTranslation } from "react-i18next";
import "../i18n";

export default function Home() {

    const { t } = useTranslation();

    return (
        <div className="container mx-auto px-3">
            <h1 className="text-center mt-10 text-sm md:text-md lg:text-lg 2xl:text-2xl font-md mb-5">{t('category_title')}</h1>
            <Categories />
            {/* <News /> */}
            <Subscribe />
        </div>
    );
}